import $ from 'jquery';
import Swiper, { Navigation, Pagination, Grid } from 'swiper';

import { getUrlWithVariant } from '@shopify/theme-product-form';
import { getSizedImageUrl } from '@shopify/theme-images';
import { addToCart } from '../../helpers';
import { countryFormSelecter } from '../../helpers/theme-address';
import WishlistService from '../../services/wishlist.service';

const wishlistService = new WishlistService();

// TODO : Should move to swiper-comtroller
const hasPdpImageCarousel = document.querySelector('.js-product-image-carousel');
const productBannerSelecter = document.querySelector('.js-product-banner-swiper');
const productFabricSelecter = document.querySelector('.js-product-fabric-carousel');

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Grid]);

if (hasPdpImageCarousel) {
  new Swiper('.js-product-image-carousel', {
    effect: 'fade',
    pagination: {
      el: '.js-banner-swiper-pagination',
      clickable: true,
    },
  });
}

if (productBannerSelecter) {
  new Swiper('.js-product-banner-swiper', {
    effect: 'fade',
    loop: true,
    pagination: {
      el: '.js-banner-swiper-pagination',
      clickable: true,
    },
  });
}

if (productFabricSelecter) {
  new Swiper('.js-product-fabric-carousel', {
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 25,
    grid: {
      rows: 2,
      fill: 'row',
    },

    pagination: {
      el: '.js-fabric-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.js-fabric-swiper-button-next',
      prevEl: '.js-fabric-swiper-button-prev',
    },
  });
}

const productVeriantList = document.querySelector('.product__veriants-listing');
const productVeriantListItems =
  productVeriantList && productVeriantList.querySelectorAll('.product__veriants-list-item');

const toggleVeriantSeletion = selected => {
  productVeriantListItems &&
    productVeriantListItems.forEach(productVeriantListItem => {
      productVeriantListItem.classList.remove('active');
      selected.currentTarget.classList.add('active');
    });
};

productVeriantListItems &&
  productVeriantListItems.forEach(productVeriantListItem => {
    productVeriantListItem.addEventListener('click', element => {
      const variantId = element.currentTarget.dataset.productVariantId;
      const varianTitle = element.currentTarget.dataset.productVariantTitle;
      const varianPrice = element.currentTarget.dataset.productVariantPrice;
      const varianComparePrice = element.currentTarget.dataset.productVariantComparePrice;

      const url = getUrlWithVariant(window.location.href, variantId);
      toggleVeriantSeletion(element);

      const variantTitleElement = document.querySelector('#selected-product-variant-title');
      const variantComparePriceElement = document.querySelector('.product__options-price-before');
      const variantPriceElement = document.querySelector('.product__options-price');

      variantTitleElement.innerHTML = varianTitle;

      if (variantComparePriceElement) {
        variantComparePriceElement.innerHTML = varianComparePrice;
      }

      if (variantPriceElement) {
        variantPriceElement.innerHTML = varianPrice;
      }

      setPageData(variantId);
      variantTitleElement.dataset.selectedVariantId = variantId;
      window.history.replaceState({ path: url }, '', url);
    });
  });

const hasAccordion = document.querySelector('.accordion__wrapper');

if (hasAccordion) {
  // accordion();

  // TODO : Should move to accordion-comtroller
  const accordionBtns = document.querySelectorAll('.accordion__panel--action:not(.no-click)');

  accordionBtns &&
    accordionBtns.forEach(accordion => {
      accordion.onclick = function() {
        this.classList.toggle('is-open');

        let content = this.nextElementSibling;

        if (content.style.maxHeight || content.classList.contains('is-open')) {
          //this is if the accordion is open
          content.style.maxHeight = null;
          content.style.visibility = 'hidden';
        } else {
          //if the accordion is currently closed
          content.style.maxHeight = content.scrollHeight + 'px';
          content.style.visibility = 'visible';
        }

        content.classList.toggle('is-open');
      };
    });
}

// updateCartCount();

const addToCartButton = document.querySelector('button[data-add-to-cart]');

addToCartButton &&
  addToCartButton.addEventListener('click', async () => {
    const variantTitleElement = document.querySelector('#selected-product-variant-title');
    const variantId = Number(variantTitleElement.dataset.selectedVariantId);

    addToCart(addToCartButton, variantId, 1);
  });

const setPageData = variantId => {
  const shopifyProduct = window.liquid.product;
  const variant = shopifyProduct.variants.find(variant => variant.id === Number(variantId));
  const productImage = variant.featured_image
    ? variant.featured_image.src
    : shopifyProduct.featured_image;
  const productImageUrl = getSizedImageUrl(productImage, '620x620');
  const newProductData = {
    et: 1,
    empi: shopifyProduct.id,
    epi: variant.id,
    dt: shopifyProduct.title,
    vi: variant.title,
    du: `https://poliform-au.myshopify.com/products/${shopifyProduct.handle}`,
    ct: shopifyProduct.type,
    pr: variant.price / 100,
    iu: productImageUrl,
    variants: [{ [variant.title]: variant.id }],
    ...(variant.compare_at_price && { op: variant.compare_at_price / 100 }),
  };

  wishlistService.checkSwymLoaded().then(async () => {
    Object.assign(SwymPageData, newProductData);
    const wishlists = await wishlistService.getAllWishlists();
    let productsInWishlists = [];

    wishlists.forEach(wishlist => {
      const productsInWishlist = [...wishlist.listcontents];
      productsInWishlists = [...productsInWishlists, ...productsInWishlist];
    });
    const isInWishlist = !!productsInWishlists.find(function(p) {
      return p.empi == shopifyProduct.id && p.epi == variant.id;
    });
    const wishlistButton = document.querySelector('.wishlist-btn');
    if (isInWishlist) {
      wishlistButton.disabled = true;
      wishlistButton.innerHTML = 'Added to Wishlist';
    } else {
      wishlistButton.disabled = false;
      wishlistButton.innerHTML = 'Add to Wishlist';
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  const variantId = Number(
    document.querySelector('[data-selected-variant-id]').dataset.selectedVariantId
  );
  setPageData(variantId);

  function swymCallbackFn() {
    const wishlistButton = document.querySelector('.wishlist-btn');

    if (wishlistButton) {
      wishlistService.checkSwymLoaded().then(async () => {
        const wishlists = await wishlistService.getAllWishlists();
        let productsInWishlists = [];

        wishlists.forEach(wishlist => {
          const productsInWishlist = [...wishlist.listcontents];
          productsInWishlists = [...productsInWishlists, ...productsInWishlist];
        });

        const activeProductId = SwymPageData.empi;
        const activeVariantId = SwymPageData.epi;

        const isInWishlist = !!productsInWishlists.find(function(p) {
          return p.empi == activeProductId && p.epi == activeVariantId;
        });

        if (isInWishlist) {
          wishlistButton.setAttribute('disabled', true);
          wishlistButton.innerHTML = 'Added to Wishlist';
        } else {
          wishlistButton.addEventListener('click', function() {
            if (SwymPageData) {
              var swymPageDataToAdd = Object.assign({}, SwymPageData, { et: 4 });
              _swat.addToWishList(swymPageDataToAdd, function() {
                // Emit all immediately available variant data as event. (This data is captured and used for analytics)
                const variantData = {
                  id: swymPageDataToAdd.epi,
                  title: swymPageDataToAdd.vi || swymPageDataToAdd.dt,
                  productTitle: swymPageDataToAdd.dt,
                  sku: window.liquid.product.variants.find(
                    variant => variant.id === swymPageDataToAdd.epi
                  ).sku,
                  type: swymPageDataToAdd.ct,
                  price: swymPageDataToAdd.pr,
                  vendor: window.liquid.product.vendor,
                };
                wishlistButton.innerHTML = 'Saved to Wishlist';
                document.dispatchEvent(
                  new CustomEvent('product-added-to-wishlist', { detail: variantData })
                );
              });
            }
          });
        }
      });
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  const downloadLinkEls = document.querySelectorAll('a[download]');

  if (!downloadLinkEls) return;

  downloadLinkEls.forEach(downloadLinkEl => {
    downloadLinkEl.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'Product Download',
        productName: window.liquid.product.title,
        productCategory: window.liquid.product.type,
      });
    });
  });
});

// Enquery form

const countrySelecter = document.querySelector('[data-address-autofill-country-selecter]');

if (countrySelecter) {
  countryFormSelecter(countrySelecter);
}

$(document).on('change', '[data-enquiry-type-selecter]', function() {
  const slectedValue = $(this).val();
  const isCommercialSlected = slectedValue === 'Commercial';

  if (isCommercialSlected) {
    $('[data-form-field-company]')
      .removeClass('d-none')
      .show();
  } else {
    $('[data-form-field-company]')
      .addClass('d-none')
      .hide();
  }
});
